import { SaveOutlined } from "@ant-design/icons";
import { Col, InputNumber, Row } from "antd";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Button from "../../components/functional_components/Button/PFButton";
import DetailBox from "../../components/functional_components/DetailBox/DetailBox";
import { setLoading } from "../../redux/ducks/Loading";
import FlatRateAmount from "../../services/api/FlatRateAmount";
import { showError, showSuccess, trimData } from "../../utils/utilities";
import { useFormik } from "formik";

const FlatRateAmounts = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    loading: false,
    data: {},
  });

  useEffect(() => {
    dataList();
  }, []);

  const dataList = async () => {
    dispatch(setLoading(true));
    const { error, data } = await FlatRateAmount.getFlatRateAmount();
    if (!error && data) {
      setState((prevState) => ({ ...prevState, data }));
    } else {
      showError(get(error, "messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const formikFlatRateAmount = useFormik({
    initialValues: {
      internal: get(state.data, "internal", ""),
      abroad: get(state.data, "abroad", ""),
    },
    validate: (values) => {
      values = trimData(values);
      let errors = {};
      if (!values.internal) {
        errors.internal = "Required!";
      }
      if (!values.abroad) {
        errors.abroad = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      setState((prevState) => ({ ...prevState, loading: true }));
      const data = {
        id: 1,
        internal: values.internal,
        abroad: values.abroad,
      };
      const saveResponse = await FlatRateAmount.saveFlatRateAmount(data);
      if (!saveResponse.error) {
        showSuccess();
        dataList();
      } else {
        showError(get(saveResponse, "error.messageCode", "ER000"));
      }
      setState((prevState) => ({ ...prevState, loading: false }));
    },
  });

  return (
    <DetailBox title={t("menuLeft.flatRateAmount")}>
      <Row>
        <Col span={12}>
          <Row>
            <label htmlFor="internal" className="fw-bold">
              {t("flatRateAmount.internal")}
            </label>
          </Row>
          <Row className="mt-10">
            <InputNumber
              controls={false}
              className="mt-10"
              id="internal"
              name="internal"
              value={formikFlatRateAmount.values.internal}
              onChange={(e) => formikFlatRateAmount.setFieldValue("internal", e)}
              onBlur={formikFlatRateAmount.handleBlur}
              precision={2}
              decimalSeparator=","
            />
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <label htmlFor="abroad" className="fw-bold">
              {t("flatRateAmount.abroad")}
            </label>
          </Row>
          <Row className="mt-10">
            <InputNumber
              controls={false}
              className="mt-10"
              id="abroad"
              name="abroad"
              value={formikFlatRateAmount.values.abroad}
              onChange={(e) => formikFlatRateAmount.setFieldValue("abroad", e)}
              onBlur={formikFlatRateAmount.handleBlur}
              precision={2}
              decimalSeparator=","
            />
          </Row>
        </Col>
      </Row>
      <Button
        floatRight
        currentSize="large"
        currentIcon={<SaveOutlined className="icon-medium" />}
        clickCallback={formikFlatRateAmount.submitForm}
        isLoading={state.loading}
        isDisabled={!(formikFlatRateAmount.dirty && formikFlatRateAmount.isValid)}
      />
    </DetailBox>
  );
};

export default FlatRateAmounts;
